import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { Header } from 'semantic-ui-react';
import urls, { relativeUrl } from '@/constants/urls';

const HomeBannerAdvanced = ({ compact }) => {
  const intl = useIntl();
  return (
    <>
      <Header.Subheader
        as="a"
        className={clsx(
          'tc mt-10 flex items-center justify-end w-100 aridhia-home-advanced-search link',
          compact && 'mr-25',
        )}
        content={intl.formatMessage({ id: 'home.banner.advanced.search' })}
        href={`#${relativeUrl(urls.SEARCH)}`}
        target="_self"
      />
    </>
  );
};

export default HomeBannerAdvanced;
